import { render, staticRenderFns } from "./SidekiqLinks.vue?vue&type=template&id=5af2fef6&"
import script from "./SidekiqLinks.vue?vue&type=script&lang=ts&"
export * from "./SidekiqLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports